<template>
  <b-container fluid>
    <search fields="Betrieb,Von,Bis,Probetyp,Tierart" @filterdata="filterAnalysen"></search>

    <b-nav tabs>
      <b-nav-item :to="'/'+lang+'/analysen/tabelle'" active>
        <strong>
          <span class="glyphicons glyphicons-table"></span>
          {{$t('Tabelle')}}
        </strong>
      </b-nav-item>
      <b-nav-item :to="'/'+lang+'/analysen/grafik'">
        <strong>
          <span class="glyphicons glyphicons-cardio"></span>
          {{$t('Grafik')}}
        </strong>
      </b-nav-item>
    </b-nav>

    <table-responsive
      ref="tableResponsiveAnalysen"
      :items="analysen"
      responsive
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :field-definition="fields"
      :sortCompare="sortCompare"
    >
      <template v-slot:MPDREFCODELABOR="data">
        <a
          href="#"
          @click.prevent="showDetail(data.item.MPDREFCODELABOR)"
        >{{data.item.MPDREFCODELABOR}}</a>
        <a :href="getPBURL(data.item.MPDID,data.item.MPDDATUM,data.item.ANATYPID)">
          <span class="glyphicons glyphicons-disk-save"></span>
        </a>
      </template>
      <template v-slot:ANATYPCODE="data">
        {{$t('CODANATYP_'+data.item.ANATYPID)}}
        <template v-if="data.item.MPDRELEVANT == '1'">{{$t('fuerMW')}}</template>
      </template>
      <template v-slot:MPDHEMMSTOFF="data">
        <template v-if="data.item.MPDHEMMSTOFF == 0">neg</template>
        <template v-if="data.item.MPDHEMMSTOFF == 1">pos</template>
      </template>
      <template v-slot:MPDDATUM="data">
        {{formatDate(data.item.MPDDATUM)}}
        <template v-if="data.item.MPDSTORNIERUNG">
          <br />
          <b>{{$t('Storniert')}}</b>
        </template>
      </template>
      <template v-slot:MPDMSGCODELABOR="data" :id="'MPX'+data.item.MPDID">
        <div v-if="data.item.MPDMSGCODELABOR>=1" :id="'MPDIV'+data.item.MPDID">
          <!--  <b-btn :id="'MP'+data.item.MPDID"> {{data.item.MPDMSGCODELABOR}} </b-btn>-->
          <b-link :id="'MP'+data.item.MPDID">{{data.item.MPDMSGCODELABOR}}</b-link>
          <b-popover
            :target="'MPDIV'+data.item.MPDID"
            :title="$t('Fehlercode')"
            triggers="hover focus"
            :content="$t('MP_'+data.item.MPDMSGCODELABOR)"
          ></b-popover>
        </div>
      </template>
    </table-responsive>
    <div class="text-right mt-3">
      <a :href="rekapURL">{{ $t('Druckansicht') }}</a>
      <br />
      <a :href="excelURL">{{ $t('Excel') }}</a>
      <br />
      <a
        :href="'/resources/1/uploads/' + $t('Erklaerungen') + '_pis.pdf'"
        target="_blank"
      >{{ $t('Erklaerungen') }}</a>
    </div>

    <analysen-detail ref="analysenDetail"></analysen-detail>
  </b-container>
</template>

<script>
import { apiURL, i18n } from "../main";
import analysenMixin from "../components/AnalysenMixin.js";
//import analysen from "../store/analysen";
import TableResponsive from "../components/tableResponsive.vue";
import analysenCalcCharts from "../components/AnalysenCalcCharts_Mixin.js";
import analysenFilter from "../components/AnalysenFilter_Mixin.js";
import AnalysenDetail from "../components/AnalysenDetail.vue";
import moment from "moment";

//Vue.component('charts-container',ChartsContainer)

export default {
  name: "hello",
  props: {
    lang: String
  },
  mixins: [
    analysenMixin,
    analysenCalcCharts,
    analysenFilter
  ] /* call the mixins fn getChart() like am member fn:  this.getChart(); */,
  data() {
    return {
      analysenIntervall: 0,
      //tabIndex: 0,
      actionListener: {},
      filterText: ""
    };
  },
  computed: {
    rekapURL() {
      return (
        apiURL +
        "analysen.cfc?method=printRekap" +
        "&von=" +
        moment(this.$store.state.searchStore.searchValues.von).toISOString() +
        "&bis=" +
        moment(this.$store.state.searchStore.searchValues.bis).toISOString() +
        "&tierart=" +
        this.$store.state.searchStore.searchValues.tierartSelected +
        "&probetyp=" +
        this.$store.state.analysenStore.anatypSelected +
        "&btrid=" +
        this.$store.state.searchStore.searchValues.betriebSelected +
        "&language=" +
        i18n.locale
      );
    },
    excelURL() {
      return (
        apiURL +
        "analysen.cfc?method=getAnalysenXLS" +
        "&von=" +
        moment(this.$store.state.searchStore.searchValues.von).toISOString() +
        "&bis=" +
        moment(this.$store.state.searchStore.searchValues.bis).toISOString() +
        "&tierart=" +
        this.$store.state.searchStore.searchValues.tierartSelected +
        "&probetyp=" +
        this.$store.state.analysenStore.anatypSelected +
        "&btrid=" +
        this.$store.state.searchStore.searchValues.betriebSelected +
        "&language=" +
        i18n.locale
      );
    }
  },
  methods: {
    getPBURL(mpdID, datum, ANATYPID) {
      return (
        apiURL +
        "analysen.cfc?method=printPruefbericht&id=" +
        mpdID +
        "&jahr=" +
        moment(datum).year() +
        "&anatypid=" +
        ANATYPID +
        "&language=" +
        i18n.locale
      );
    }
  },
  components: {
    "table-responsive": TableResponsive,
    "analysen-detail": AnalysenDetail
  }
};
</script>